<template>
  <nav class="pb-8 lg:px-10 lg:pb-0 lg:w-fit">
    <ul
      class="flex h-full items-end flex-col gap-4 pt-5 text-lg lg:gap-2 lg:pt-0 lg:text-lg lg:font-regular"
      @mouseenter="isHovering = true"
      @mouseleave="isHovering = false"
    >
      <li
        v-for="(link, i) in mainMenuLinks"
        :key="`global_${i}`"
        class="relative"
      >
        <VuepalLink
          :to="link.href"
          class="group h-12 flex overflow-hidden items-center transition-all ease-out duration-300 bg-lightGreen rounded-full text-darkGreen hover:bg-white hover:text-darkGreen border-1 border-lightGreen hover:drop-shadow-[0_4px_30px_rgba(0,0,0,0.05)]"
          :active-class="'main-menu-link-active bg-white text-darkGreen border-1 border-lightGreen filter drop-shadow-[0_4px_30px_rgba(0,0,0,0.05)]'"
        >
          <div
            class="whitespace-nowrap inline-block transition-all ease-out duration-300 overflow-hidden"
            :class="[
              !isScrolled || isHovering
                ? 'opacity-100 max-w-75'
                : 'opacity-0 max-w-0',
            ]"
          >
            <span class="p-4">{{ link.label }}</span>
          </div>

          <MediaIcon
            v-if="link.icon"
            v-bind="link.icon"
            class="size-12 p-2 inline-block z-10 bg-lightGreen transition-all ease-out duration-300 group-hover:bg-transparent group-hover:transition-all group-hover:ease-out group-hover:duration-200"
            :class="[
              isHovering
                ? 'bg-transparent transition-all ease-out duration-200'
                : '',
            ]"
          />
          <SpriteSymbol
            v-else
            name="paperplane"
            alt="AOZ logo"
            class="size-12 p-2 inline-block z-10 bg-lightGreen rounded-full transition-all ease-out duration-300 group-hover:bg-transparent group-hover:transition-all group-hover:ease-out group-hover:duration-300"
            :class="[
              isHovering
                ? 'bg-transparent transition-all ease-out duration-300'
                : '',
            ]"
          />
        </VuepalLink>
      </li>
    </ul>
  </nav>
</template>

<script lang="ts" setup>
import { SCREENS } from '~~/tailwind/screens'

const { mainMenuLinks } = useInitData()
const isHovering = ref(false)
const isScrolled = ref(false)

const checkScroll = (): void => {
  const isDesktop = window.matchMedia(`(min-width: ${SCREENS.sm}px)`).matches
  isScrolled.value = window.scrollY > 10 && isDesktop
}

onMounted(() => {
  checkScroll()
  window.addEventListener('scroll', checkScroll, { passive: true })
  window.addEventListener('resize', checkScroll, { passive: true })
})

onUnmounted(() => {
  window.removeEventListener('scroll', checkScroll)
  window.removeEventListener('resize', checkScroll)
})
</script>

<style>
@reference "~/assets/css/tailwind.css";

.main-menu-link-active {
  svg {
    @apply bg-transparent transition-all ease-out duration-300;
  }
}
</style>
